const TOKEN = `onClick=window.open("https://www.clicklease.com/partner/dyco-ventures");`;

setTimeout(function () {
  start();
}, 500);

function start() {
  // PDP / product context
  if (!document.querySelector('.ClkButton') && document.querySelector('.product-single__meta')) {
    renderButton();
  }

  // Do NOT render on collection product cards
  // Original script also targeted ".product-grid-container .collection"
  // We intentionally skip that to avoid showing financing on collection cards.

  RenderNav();
}

function renderButton() {
  // Primary PDP price block
  let place = document.querySelector('.product-pricing');

  // Fallback for contexts without .product-pricing (e.g. featured product section)
  if (!place) {
    const meta = document.querySelector('.product-single__meta');
    if (meta) {
      // Insert after unit price if present, otherwise after main price, otherwise at bottom of meta
      place =
        meta.querySelector('.product__unit-price') ||
        meta.querySelector('.product__price') ||
        meta;
    }
  }

  const priceEl =
    (place &&
      place.querySelector &&
      (place.querySelector('.product__price.sale-price') ||
        place.querySelector('.product__price'))) ||
    document.querySelector('.product__price.sale-price') ||
    document.querySelector('.product__price');

  if (!place || !priceEl) return;

  const amount = Number(priceEl.innerText.replace(/[^0-9.]+/g, ''));

  if (amount >= 500 && amount <= 30000) {
    validation(amount, place);
  }
}

// Collection list version intentionally NOT used
function renderButtonList() {
  const places = document.querySelectorAll('.card-information');
  places.forEach((element) => {
    const place = element.querySelector('.price__container');
    const price = element.querySelector('.price-item.price-item--sale.price-item--last');

    if (place && price) {
      const amount = Number(price.innerText.replace(/[^0-9.]+/g, ''));
      if (amount >= 500 && amount <= 30000) {
        validation(amount, place);
      }
    }
  });
}

function validation(amount, place) {
  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function (event) {
    if (this.readyState === 4 && this.status === 200) {
      const divContainer = document.createElement('div');
      divContainer.className = 'ClkButton';
      divContainer.setAttribute(
        'style',
        'width: 100%; cursor: pointer; position: relative;'
      );
      place.after(divContainer);
      divContainer.innerHTML = buttonPriceNew(event);
    }
  };
  xhttp.open(
    'GET',
    'https://app.clicklease.com/api/estimatedPaymentAmount/' + amount,
    true
  );
  xhttp.send();
}

const buttonPriceNew = (event) =>
  `<svg ${TOKEN} style="width: 100%;margin-top: -3%;margin-bottom:-3%;cursor: pointer;max-width: 500px;"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 75" width="100%" height="100">
  <style>
    .clk__svg text {
      text-rendering: optimizeLegibility !important;
      -webkit-font-smoothing: antialiased !important;
      text-transform: none !important;
      text-decoration: none !important;
      line-height: normal !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    .clk__svg .clk__text {
      font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif !important;
      fill: #222 !important;
      font-size: 19px !important;
      font-weight: 400 !important;
      letter-spacing: 0.4px !important;
      word-spacing: 1px !important;
    }
    .clk__svg .clk__price {
      font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif !important;
      fill: #02ADEE !important;
      font-size: 19px !important;
      font-weight: 600 !important;
      letter-spacing: 0.3px !important;
    }
    .clk__svg .clk__click {
      font-family: 'Helvetica Neue', Arial, sans-serif !important;
      fill: #02ADEE !important;
      font-size: 20px !important;
      font-weight: 700 !important;
    }
    .clk__svg .clk__lease {
      font-family: 'Helvetica Neue', Arial, sans-serif !important;
      fill: #555 !important;
      font-size: 20px !important;
      font-weight: 700 !important;
    }
    .clk__svg .clk__btn {
      font-family: 'Helvetica Neue', Arial, sans-serif !important;
      fill: #fff !important;
      font-size: 12px !important;
      font-weight: 700 !important;
      letter-spacing: 1.5px !important;
    }
  </style>

  <g class="clk__svg">
  <text x="10" y="55" class="clk__text">As low as</text>
  <text x="105" y="56" class="clk__price">$${JSON.parse(event.currentTarget.response)["object"]}</text>
  <text x="150" y="55" class="clk__text">/mo with</text>

  <g transform="translate(152.5,35) scale(1.14)">
    <path d="M316.966,16.08a5.873,5.873,0,1,1,0-7.367l6.058-2.7a12.4,12.4,0,1,0,0,12.768Z" transform="translate(-228)" fill="#20b6f1"></path>
    <path d="M326.7,6.751l-6.126,2.733-6.129,2.731,6.129,2.733,6.126,2.734-1.622-5.463Z" transform="translate(-227.6 0.18)" fill="#636363"></path>
  </g>

  <text x="270" y="55" class="clk__click">click</text>
  <text x="315" y="55" class="clk__lease">lease</text>

  <rect x="370" y="37" width="110" height="27" rx="13" fill="#20b6f1"></rect>
  <text x="380" y="55" class="clk__btn">APPLY NOW</text>
  </g>
</svg>`;

function RenderNav() {
  if (!document.querySelector('.ClickleaseNav')) {
    const navClass = 'ClickleaseNav mobile-nav__item appear-animation appear-delay-8';
    const navClassD = 'site-nav__item site-nav__expanded-item';

    const navItemDesktop = document.createElement('li');
    const navItemMobile = document.createElement('li');
    navItemDesktop.className = navClassD;
    navItemMobile.className = navClass;

    const navInnerD = `<a  style="cursor:pointer" class="site-nav__link aw-font-kanit aw-text-base aw-font-bold aw-leading-6 aw-uppercase" ${TOKEN}> Financing</a>`;
    const navInnerM = `<a class="root-link" ${TOKEN}> Financing</a>`;
    navItemDesktop.innerHTML = navInnerD;
    navItemMobile.innerHTML = navInnerM;

    const navDesktop = document.querySelector('.site-nav.site-navigation.medium-down--hide');
    const navMobile = document.querySelector('.mobile-nav');

    if (navDesktop && navDesktop.lastElementChild) {
      navDesktop.lastElementChild.before(navItemDesktop);
    }
    if (navMobile && navMobile.lastElementChild && navMobile.lastElementChild.previousElementSibling) {
      navMobile.lastElementChild.previousElementSibling.before(navItemMobile);
    }
  }
}

